var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_82)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 75,
    height: 75,
    rx: 11,
    fill: "#4A9A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 6.5,
    width: 74,
    height: 74,
    rx: 10.5,
    stroke: "#CFE7E4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2884 50.7246C47.6739 51.0236 49.2025 51.1863 50.8143 51.1863C53.6966 51.1863 56.3641 50.6596 58.3563 49.7573C59.3508 49.3069 60.2311 48.7384 60.8793 48.0442C61.5334 47.3438 62 46.4568 62 45.4255H59.5783C59.5783 45.6416 59.4867 45.9432 59.1312 46.3238C58.77 46.7107 58.1894 47.1157 57.3788 47.4829C55.7609 48.2157 53.441 48.7004 50.8143 48.7004C49.3585 48.7004 47.9975 48.5531 46.7866 48.2918L46.2884 50.7246Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7258 44.7299C45.6594 45.5147 48.1367 45.9648 50.8143 45.9648C53.6966 45.9648 56.3641 45.4381 58.3563 44.5358C59.3508 44.0853 60.2311 43.5168 60.8793 42.8227C61.5334 42.1223 62 41.2353 62 40.2039H59.5783C59.5783 40.4201 59.4867 40.7217 59.1312 41.1023C58.77 41.4891 58.1894 41.8942 57.3788 42.2613C55.7609 42.9941 53.441 43.4788 50.8143 43.4788C48.3785 43.4788 46.213 43.0662 44.616 42.4181L43.7258 44.7299Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2723 39.3142C45.2645 40.2166 47.932 40.7433 50.8143 40.7433C53.6966 40.7433 56.3641 40.2166 58.3563 39.3142C59.3508 38.8638 60.2311 38.2953 60.8793 37.6011C61.5334 36.9007 62 36.0138 62 34.9824H59.5783C59.5783 35.1986 59.4867 35.5001 59.1312 35.8808C58.77 36.2676 58.1894 36.6726 57.3788 37.0398C55.7609 37.7726 53.441 38.2573 50.8143 38.2573C48.1876 38.2573 45.8677 37.7726 44.2498 37.0398C43.4392 36.6726 42.8586 36.2676 42.4974 35.8808C42.1419 35.5001 42.0503 35.1986 42.0503 34.9824H39.6286C39.6286 36.0138 40.0952 36.9007 40.7493 37.6011C41.3975 38.2953 42.2778 38.8638 43.2723 39.3142Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2723 34.0927C45.2645 34.995 47.932 35.5217 50.8143 35.5217C53.6966 35.5217 56.3641 34.995 58.3563 34.0927C59.3508 33.6423 60.2311 33.0738 60.8793 32.3796C61.5334 31.6792 62 30.7923 62 29.7609C62 28.7295 61.5334 27.8425 60.8793 27.1421C60.2311 26.448 59.3508 25.8795 58.3563 25.429C56.3641 24.5267 53.6966 24 50.8143 24C47.932 24 45.2645 24.5267 43.2723 25.429C42.2778 25.8795 41.3975 26.448 40.7493 27.1421C40.0952 27.8425 39.6286 28.7295 39.6286 29.7609C39.6286 30.7923 40.0952 31.6792 40.7493 32.3796C41.3975 33.0738 42.2778 33.6423 43.2723 34.0927ZM42.4974 30.6592C42.1419 30.2786 42.0503 29.977 42.0503 29.7609C42.0503 29.5447 42.1419 29.2431 42.4974 28.8625C42.8586 28.4757 43.4392 28.0706 44.2498 27.7035C45.8677 26.9707 48.1876 26.486 50.8143 26.486C53.441 26.486 55.7609 26.9707 57.3788 27.7035C58.1894 28.0706 58.77 28.4757 59.1312 28.8625C59.4867 29.2431 59.5783 29.5447 59.5783 29.7609C59.5783 29.977 59.4867 30.2786 59.1312 30.6592C58.77 31.0461 58.1894 31.4511 57.3788 31.8183C55.7609 32.5511 53.441 33.0358 50.8143 33.0358C48.1876 33.0358 45.8677 32.5511 44.2498 31.8183C43.4392 31.4511 42.8586 31.0461 42.4974 30.6592Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0503 40.9098L42.0503 29.7609H39.6286L39.6287 40.9098H42.0503Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8143 53.9219C49.0401 53.9219 47.3964 53.7003 46.0114 53.3252L45.3936 55.7289C46.9986 56.1636 48.8514 56.4079 50.8143 56.4079C53.6966 56.4079 56.3641 55.8812 58.3564 54.9788C59.3508 54.5284 60.2311 53.9599 60.8794 53.2657C61.5334 52.5653 62 51.6784 62 50.647L62 29.7609H59.5783L59.5784 50.647C59.5784 50.8632 59.4867 51.1647 59.1313 51.5454C58.77 51.9322 58.1895 52.3372 57.3789 52.7044C55.7609 53.4372 53.441 53.9219 50.8143 53.9219Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50.3086C25 56.7656 30.099 62 36.3889 62C42.6788 62 47.7777 56.7656 47.7777 50.3086C47.7777 43.8515 42.6788 38.6171 36.3889 38.6171C30.099 38.6171 25 43.8515 25 50.3086ZM36.3889 59.514C31.4364 59.514 27.4216 55.3926 27.4216 50.3086C27.4216 45.2245 31.4364 41.1031 36.3889 41.1031C41.3413 41.1031 45.3561 45.2245 45.3561 50.3086C45.3561 55.3926 41.3413 59.514 36.3889 59.514Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8265 53.2956H32.8502V55.7816H37.8265C39.6556 55.7816 41.1384 54.2593 41.1384 52.3817C41.1384 50.5041 39.6557 48.9817 37.8265 48.9817H35.5171C35.0705 48.9817 34.7085 48.61 34.7085 48.1516C34.7085 47.6931 35.0705 47.3215 35.5171 47.3215H39.4161V44.8355H35.5171C33.7331 44.8355 32.2869 46.3202 32.2869 48.1516C32.2869 49.983 33.7331 51.4676 35.5171 51.4676H37.8265C38.3181 51.4676 38.7167 51.8769 38.7167 52.3817C38.7167 52.8864 38.3181 53.2956 37.8265 53.2956Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1781 43.4821V46.0785H37.5997V43.4821H35.1781Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1781 54.5386V57.1351H37.5997V54.5386H35.1781Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_82",
    x: 0,
    y: 0,
    width: 89,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345833 0 0 0 0 0.345833 0 0 0 0 0.345833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_82"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_82",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.b2e522209b3ee19c47af49d985fdc3e3.svg";
export { ForwardRef as ReactComponent };